import R from 'ramda';
import talk, * as talkSelectors from './talkReducer';

export default talk;

const getTalkState = R.prop('talk');

// talkSelectors
export const getInitial = R.pipe(getTalkState, talkSelectors.getInitial);
export const getConversationState = R.pipe(
  getTalkState,
  talkSelectors.getConversationState,
);
export const getTenantId = R.pipe(getTalkState, talkSelectors.getTenantId);
export const getAdvertiserId = R.pipe(
  getTalkState,
  talkSelectors.getAdvertiserId,
);
export const getAcceptedBy = R.pipe(getTalkState, talkSelectors.getAcceptedBy);
export const getCurrency = R.pipe(getTalkState, talkSelectors.getCurrency);
export const getDeclinedBy = R.pipe(getTalkState, talkSelectors.getDeclinedBy);
export const getDeposit = R.pipe(getTalkState, talkSelectors.getDeposit);
export const getDepositWithCurrency = R.pipe(
  getTalkState,
  talkSelectors.getDepositWithCurrency,
);
export const getEndDate = R.pipe(getTalkState, talkSelectors.getEndDate);
export const getStateChangedAt = R.pipe(
  getTalkState,
  talkSelectors.getStateChangedAt,
);
export const getFee = R.pipe(getTalkState, talkSelectors.getFee);
export const getConversationId = R.pipe(
  getTalkState,
  talkSelectors.getConversationId,
);
export const getPrice = R.pipe(getTalkState, talkSelectors.getPrice);
export const getStartDate = R.pipe(getTalkState, talkSelectors.getStartDate);
export const getStateHistory = R.pipe(
  getTalkState,
  talkSelectors.getStateHistory,
);
export const getTotal = R.pipe(getTalkState, talkSelectors.getTotal);
export const getAgencyFee = R.pipe(getTalkState, talkSelectors.getAgencyFee);
export const getAlias = R.pipe(getTalkState, talkSelectors.getAlias);
export const getCity = R.pipe(getTalkState, talkSelectors.getCity);
export const getCountry = R.pipe(getTalkState, talkSelectors.getCountry);
export const getExclusions = R.pipe(getTalkState, talkSelectors.getExclusions);
export const getListingId = R.pipe(getTalkState, talkSelectors.getListingId);
export const getMinimumStayMonths = R.pipe(
  getTalkState,
  talkSelectors.getMinimumStayMonths,
);
export const getListingPath = R.pipe(
  getTalkState,
  talkSelectors.getListingPath,
);
export const getStreet = R.pipe(getTalkState, talkSelectors.getStreet);
export const getTenant = R.pipe(getTalkState, talkSelectors.getTenant);
export const getAdvertiser = R.pipe(getTalkState, talkSelectors.getAdvertiser);
export const getPhotoUrlList = R.pipe(
  getTalkState,
  talkSelectors.getPhotoUrlList,
);
export const getMessages = R.pipe(getTalkState, talkSelectors.getMessages);

export const getIsListingDeleted = state => state.talk.listing.isDeleted;
export const getIsListingHidden = state => state.talk.listing.isHidden;
export const getListingStartDate = state =>
  state.talk.listing.firstBookableDate;
export const getListingEndDate = state => state.talk.listing.lastBookableDate;
export const getEntityBookablePeriods = state =>
  state.talk.listing.entityBookablePeriods || {};
export const getListingBookablePeriods = state =>
  getEntityBookablePeriods(state).bookablePeriods;
export const getListingMaxBookableDays = state =>
  getEntityBookablePeriods(state).maxBookableDays;

export const getError = R.pipe(getTalkState, talkSelectors.getError);
export const getIsLoading = R.pipe(getTalkState, talkSelectors.getIsLoading);
